import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const LinkArrow = ({ size, color, link }) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (!link) {
      navigate(-1);
    } else {
      navigate(link);
    }
  };

  return <ArrowBackIosIcon onClick={handleNavigation} />;
};

export default LinkArrow;
